// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
//

import {Browser} from "@lib/browser/Browser";

const dmsDetectionUrlPolicyName = "DmsDetectionUrlFilters";
const defaultDmsDetectionUrl: string = "*://*/*DmsInitializationForm.aspx*";

export async function getDmsDetectionUrls(): Promise<string[]> {
  try {
    const policyDefinedDetectionUrlsJson = await Browser.storage.managed.get<string>(dmsDetectionUrlPolicyName);
    if (policyDefinedDetectionUrlsJson !== null) {
      const policyDefinedDetectionUrls = JSON.parse(policyDefinedDetectionUrlsJson) as string[];

       return policyDefinedDetectionUrls !== null && policyDefinedDetectionUrls.length !== 0
        ? policyDefinedDetectionUrls
        : [defaultDmsDetectionUrl];
    }
    return [defaultDmsDetectionUrl];
  } catch (e) {
    return [defaultDmsDetectionUrl];
  }
}